import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { useCallback, useContext } from "react";
import { getPickTitle } from "./util";

/** `getPickTitle` with the team's "full product titles while picking" preference applied. */
export function usePickTitle(): (
  item: Parameters<typeof getPickTitle>[0],
) => string {
  const team = useContext(TeamContext);
  const preferFullTitle =
    team?.settings?.outboundLabels?.wms?.preferFullPickTitle ?? false;
  return useCallback(
    (item) => getPickTitle(item, { preferFullTitle }),
    [preferFullTitle],
  );
}
